import env from 'env';

export function resourcePath(url){
  const resourceBase = url.indexOf('/sites/vsmen') >= 0? env.resourceBaseMen : env.resourceBaseWomen;
  //console.log(resourceBase, url, env.resourceBaseMen)
  return isExternalLink(url)? url : resourceBase + url;
}

export function isExternalLink(link){
  return link && (link.indexOf('https://') === 0 || link.indexOf('http://') === 0 || link.indexOf('://') === 0);
}

export function getLinkFromElement(el){
  if (!el) return null;
  const linkEl = el.closest('a');
  //console.log(el, linkEl);
  if (linkEl){
    return linkEl.getAttribute('href');
  }
  return null;
}


// router utils
export function getLinkInfo(link) {
  if (!link) return null;

  const origin = window && window.location && window.location.origin;
  let linkFiltered = link.replace(origin, '');
  let linkLower = link.toLowerCase();

  if (isStaticFile(linkLower)) return null;
  const isExternal = isExternalLink(link);
  const isHash = link.indexOf('#') === 0;
  const isTel = link.indexOf('tel:') === 0;
  const type = (isHash && 'hash') || (isTel && 'tel') || (isExternal && 'external') || 'internal';

  return { url: linkFiltered, type: type };
}

var exts = ['.pdf', '.jpg', '.png', '.gif', '.docx']
function isStaticFile(path) {
  for(let i = 0; i < exts.length; i++) {
    if (path.indexOf(exts[i]) >= 0) return true;
  }
  return false;
}

//
export function toQueryString(params) {
  var queryString = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
  }).join('&');
  return queryString;
}

export function getYoutubeId(url){
  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}